export const PLANE_LENGTH = 770
export const PLANE_HEIGHT = 450
export const PLANE_GAME_LENGTH = 50
export const SOLDIER_RADIUS = 7
export const EXPLOSION_RADIUS = 12
export const FUNCTION_VELOCITY = 1500

export interface Soldier {
  x: number
  y: number
  alive: boolean
}

export interface Player {
  id: string
  name: string
  team: number
  connected: boolean
  ready: boolean
  soldiers: Soldier[] | null
  current: number
}

export interface Circle {
  x: number
  y: number
  r: number
}

export interface Terrain {
  circles: Circle[]
  explosions: Circle[]
}

export interface Turn {
  player: number
  soldier: number
  remainingMs: number
  locked: boolean
}

export interface StateMsg {
  t: 'state'
  phase: 'lobby' | 'playing' | 'over'
  code: string
  host: string
  soldiersPerPlayer: number
  players: Player[]
  terrain: Terrain | null
  turn: Turn | null
  winner: number
  skipVotes: number
  matchSeq: number
}

export interface HitRef {
  player: number
  soldier: number
  step: number
}

export interface ShotMsg {
  t: 'shot'
  player: number
  soldier: number
  xs: number[]
  ys: number[]
  hits: HitRef[]
  endX: number
  endY: number
  reason: 'obstacle' | 'undefined' | 'vertical' | 'maxsteps'
  durationMs: number
}

export interface WelcomeMsg {
  t: 'welcome'
  you: string
  code: string
  token: string
}

export interface ChatMsg {
  t: 'chat'
  from?: string
  text: string
  kind?: 'system'
}

export interface FuncInfoMsg {
  t: 'funcinfo'
  player: string
  fn: string
}

export interface ErrorMsg {
  t: 'error'
  msg: string
}

export type ServerMsg = StateMsg | ShotMsg | WelcomeMsg | ChatMsg | FuncInfoMsg | ErrorMsg

export type ClientMsg =
  | { t: 'setTeam'; team: number }
  | { t: 'setSoldiers'; n: number }
  | { t: 'start' }
  | { t: 'fire'; fn: string }
  | { t: 'chat'; text: string }
  | { t: 'rematch' }

export const TEAM_COLORS: Record<number, string> = {
  1: '#3fb8af',
  2: '#e8664a',
}

export function teamColor(team: number): string {
  return TEAM_COLORS[team] ?? '#cccccc'
}
